import classNames from "classnames";
import "./dashboard-card.scss";
import { DashboardModel } from "@shared/models/dashboard-model";

export interface DashboardCardProps {
  model: DashboardModel;
  onClick?: (model: DashboardModel) => void;
}

export function DashboardCard({ model }: DashboardCardProps) {
  const { title, value, icon, description, iconClass } = model;
  return (
    <div id="DashboardCard" className="dashboard-card ">
      <div className="flex justify-between border p-6 rounded-lg">
        <div>
          <span className="block text-gray-500 font- text-sm">{title}</span>
          <div className="text-900 font-medium text-3xl">{value}</div>
        </div>
        <div
          className={classNames(
            "flex items-center justify-center rounded-lg p-3 w-16",
            iconClass
          )}
        >
          {icon}
        </div>
      </div>
      {description && <span className="text-500 text-sm">{description}</span>}
    </div>
  );
}

export default DashboardCard;
